import { render, staticRenderFns } from "./TaskCell.vue?vue&type=template&id=3b5598ad&scoped=true&lang=pug&"
import script from "./TaskCell.vue?vue&type=script&lang=js&"
export * from "./TaskCell.vue?vue&type=script&lang=js&"
import style0 from "./TaskCell.vue?vue&type=style&index=0&id=3b5598ad&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5598ad",
  null
  
)

export default component.exports